module.exports = __webpack_public_path__ + "img/right-arrow-grey.33e11575.svg";